import Menu from './Compartido/Menu.jsx';
import TextosPagoResto from './PagoResto/TextosPagoResto.jsx';
import Footer from './Compartido/Footer.jsx';

const PagoResto = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <TextosPagoResto
                datoscliente={props.datoscliente}
                datospropiedad={props.datospropiedad}
                reserva={props.reserva}
                totalesreserva={props.totalesreserva}
                restoapagar={props.restoapagar}
                config={props.config}
                tpvs={props.tpvs}
                paycomet={props.paycomet}
                tipopago={props.tipopago}
                lang={props.lang}
                ruta={props.ruta}
                moneda={props.moneda}
                transferencia={props.transferencia}
                paypal={props.paypal}
                stripe={props.stripe}
            />
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}
export default PagoResto;
